import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useProfileService } from '../../../../apis/profile/useProfileService';
import { IProfilePersonalDetailsApiResponse } from 'src/apis/profile/profilePersonalDetails.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getProfilePersonalDetailsKey = 'get-profile-personal-details';

export const useProfilePersonalDetailsHook = (
  userId: string,
  options?: Omit<
    UseQueryOptions<IProfilePersonalDetailsApiResponse, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<IProfilePersonalDetailsApiResponse, TQueryError> => {
  const { getProfileDetails } = useProfileService();

  return useQuery<IProfilePersonalDetailsApiResponse, TQueryError>({
    queryKey: [getProfilePersonalDetailsKey, userId],
    queryFn: () => getProfileDetails(userId),
    enabled: true,
    ...options,
  });
};
